import { SelectField, SegmentedField, type SelectFieldProps } from "./SelectField";
import { SparkleIcon } from "./icons";
import { cn } from "@/shared/lib/cn";

type ResolutionPickerProps = Omit<SelectFieldProps, "presentation" | "searchable" | "searchPlaceholder" | "context">;

/** All resolution menus use a neutral sliding selector and the same compact trigger. */
export function ResolutionPicker({ variant = "secondary", options, panelClassName, ...props }: ResolutionPickerProps) {
  return <SelectField {...props} variant={variant} panelClassName={cn("studio-resolution-control", panelClassName)} presentation="segmented" options={options.map(option => ({ ...option, icon: <SparkleIcon aria-hidden="true" /> }))} />;
}

/** Embed the same selector when resolution shares a popover with other settings. */
export function ResolutionControl(props: Parameters<typeof SegmentedField>[0]) {
  return <div className="studio-resolution-control"><SegmentedField {...props} /></div>;
}
